import { get } from '@va/http-client';
import { WebsitesQueryFilter, WebsiteType } from '@va/types/website';
import useSWR, { SWRConfiguration } from 'swr';

export type WebsitesDataType = {
  hasContributor: boolean;
  length: number;
  start: number;
  total: number;
  totalWhiteLabeled: number;
  websites: WebsiteType[];
};

export const useGetWebsites = (
  controller: AbortController,
  queryData: WebsitesQueryFilter,
  config: SWRConfiguration,
  userId: string,
) => {
  const fetcher = ([url, queryData, controller]: [string, any, AbortController]): any => {
    return get(url, queryData, { signal: controller.signal });
  };

  const swr = useSWR<WebsitesDataType>([`/users/${userId}/websites`, queryData, controller], fetcher, config);

  return { ...swr, controller };
};
